import { useState } from "react";
import { useTranslation } from "react-i18next";

const ContactForm = () => {
  const { t } = useTranslation();

    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");

    const [formData, setFormData] = useState({
      name: "",
      lastname: "",
      email: "",
      phone: "",
      field: "",
    });

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      e.preventDefault();

      if (
        !formData.name ||
        !formData.lastname ||
        !formData.email ||
        !formData.phone ||
        !formData.field
      ) {
        setError("Please complete all fields.");
        setSuccess(false);
        return;
      }

      setSuccess(true);
      setError("");
      setFormData({ name: "", lastname: "", email: "", phone: "", field: "" });

      try {
        const response = await fetch("https://sofia.atmnetss.com/api/hooks/sendForm", {
        // const response = await fetch("http://localhost:5002/api/hooks/sendForm", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        const result = await response.json();
        // console.log("Send email", result);
        // Puedes mostrar un mensaje de éxito aquí
      } catch (error) {
        console.error("Error al enviar el correo:", error);
        // Puedes mostrar un mensaje de error aquí
      }
    };

  return (
    <div>
      <form onSubmit={handleSubmit} className="space-y-6">
        {[
          { id: "name", label: "nombre", type: "text" },
          { id: "lastname", label: "apellido", type: "text" },
          { id: "email", label: "email", type: "email" },
          { id: "phone", label: "numero", type: "tel" },
        ].map((field) => (
          <div className="relative z-0 w-full group" key={field.id}>
            <input
              type={field.type}
              id={field.id}
              name={field.id}
              value={formData[field.id]}
              onChange={handleChange}
              placeholder=" "
              required
              className="peer block w-full rounded-lg border border-gray-300 bg-white
                px-4 pt-6 pb-2 text-sm text-gray-900 appearance-none
                focus:outline-none focus:ring-2 focus:ring-orangeAtm focus:border-orangeAtm"
            />
            <label
              htmlFor={field.id}
              className="pointer-events-none absolute left-4 top-1 bg-white px-1
                text-xs text-gray-500 transition-all
                peer-focus:-top-2 peer-focus:text-orangeAtm
                peer-[&:not(:placeholder-shown)]:-top-2"
            >
              {t(`school.${field.label}`)}*
            </label>
          </div>
        ))}

        <div className="w-full">
          <label
            htmlFor="field"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            {t("school.select_field")}**
          </label>

          <select
            id="field"
            name="field"
            value={formData.field}
            onChange={handleChange}
            required
            className="block w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-900
                        appearance-none focus:outline-none focus:ring-2 focus:ring-orangeAtm focus:border-orangeAtm"
          >
            <option value="">{t("school.select_field")}</option>
            <option value="ATM">ATM Solutions</option>
            <option value="Banking">Banking Services</option>
            <option value="Fintech">Financial Technology</option>
            <option value="Future">The Future of Banking Technology</option>
            <option value="Security">Enhancing ATM Security Systems</option>
          </select>
        </div>

        {error && <p className="text-red-500 text-sm">{error}</p>}

        {success && (
          <div
            className="flex items-center rounded-lg border border-green-300 bg-green-50 p-3 text-green-800 shadow-sm"
            role="alert"
          >
            <svg
              className="h-5 w-5 flex-shrink-0 text-green-600"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1.293-7.293a1 1 0 011.414 0L12 12.586l2.879-2.879a1 1 0 111.414 1.414l-3.586 3.586a1 1 0 01-1.414 0L8.293 12.12a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
            <span className="ml-3 text-sm font-medium">
              ¡Sent successfully!
            </span>
          </div>
        )}

        <button
          type="submit"
          className="rounded-lg border border-orangeAtm bg-orangeAtm px-6 py-2 text-white transition hover:bg-white hover:text-orangeAtm"
        >
          {t("school.submit")}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
